import { render } from "./PurchaseHistoryPage.vue?vue&type=template&id=1691ead9"
import script from "./PurchaseHistoryPage.vue?vue&type=script&lang=js"
export * from "./PurchaseHistoryPage.vue?vue&type=script&lang=js"

import "./PurchaseHistoryPage.vue?vue&type=style&index=0&id=1691ead9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__